import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SplashScreen from './components/SplashScreen';
import Login from './components/Login';
import DashboardLayout from './components/DashboardLayout';
import PublicLayout from './components/PublicLayout';
import Dashboard from './pages/Dashboard';
import Sales from './pages/Sales';
import Purchases from './pages/Purchases';
import DailyReport from './pages/DailyReport';
import SalesReturn from './pages/SalesReturn';
import TodaySales from './pages/TodaySales';
import PendingCredit from './pages/PendingCredit';
import MonthlyPurchases from './pages/MonthlyPurchases';
import StockistPurchases from './pages/StockistPurchases';
import LedgerReport from './pages/LedgerReport';
import NearExpiry from './pages/NearExpiry';
import Backups from './pages/Backups';

// Public Pages
import Home from './pages/public/Home';
import About from './pages/public/About';
import Services from './pages/public/Services';
import Contact from './pages/public/Contact';

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      {showSplash && <SplashScreen onFinish={() => setShowSplash(false)} />}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
        </Route>

        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected Dashboard Routes */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="sales" element={<Sales />} />
          <Route path="today-sales" element={<TodaySales />} />
          <Route path="pending-credit" element={<PendingCredit />} />
          <Route path="monthly-purchases" element={<MonthlyPurchases />} />
          <Route path="stockist-purchases" element={<StockistPurchases />} />
          <Route path="sales-return" element={<SalesReturn />} />
          <Route path="purchases" element={<Purchases />} />
          <Route path="daily-report" element={<DailyReport />} />
          <Route path="ledger-report" element={<LedgerReport />} />
          <Route path="near-expiry" element={<NearExpiry />} />
          <Route path="backups" element={<Backups />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
